import { ja as common } from "./common/ja.yml";
import { ja as hotel } from "./hotel/ja.yml";
import { ja as hotelRoom } from "./hotelRoom/ja.yml";
import { ja as hotelPlan } from "./hotelPlan/ja.yml";
import { ja as hotelCancelPolicy } from "./hotelCancelPolicy/ja.yml";
import { ja as hotelChildrenSetting } from "./hotelChildrenSetting/ja.yml";
import { ja as hotelMail } from "./hotelMail/ja.yml";
import { ja as hotelOption } from "./hotelOption/ja.yml";
import { ja as hotelPushMessageGroup } from "./hotelPushMessageGroup/ja.yml";
import { ja as hotelCheckIn } from "./hotelCheckIn/ja.yml";
import { ja as hotelCalendar } from "./hotelCalendar/ja.yml";
import { ja as booking } from "./booking/ja.yml";
import { ja as user } from "./user/ja.yml";
import { ja as newsletter } from "./newsletter/ja.yml";
import { ja as company } from "./company/ja.yml";

export const buttonJa: any = {
  common: common["adminButtonCommon"],
  hotel: hotel["adminButtonHotel"],
  hotelRoom: hotelRoom["adminButtonHotelRoom"],
  hotelPlan: hotelPlan["adminButtonHotelPlan"],
  hotelCancelPolicy: hotelCancelPolicy["adminButtonHotelCancelPolicy"],
  hotelChildrenSetting: hotelChildrenSetting["adminButtonHotelChildrenSetting"],
  hotelOption: hotelOption["adminHotelOption"],
  hotelMail: hotelMail["adminHotelMail"],
  hotelPushMessageGroup:
    hotelPushMessageGroup["adminButtonHotelPushMessageGroup"],
  hotelCheckIn: hotelCheckIn["adminButtonHotelCheckIn"],
  hotelCalendar: hotelCalendar["adminButtonHotelCalendar"],
  booking: booking["adminButtonBooking"],
  user: user["adminButtonUser"],
  newsletter: newsletter["adminButtonNewsletter"],
  company: company["adminButtonCompany"],
};
